import { Injectable } from "@angular/core";
import * as lscache from "lscache";

@Injectable({
  providedIn: "root",
})
export class LocalStorageCacheService {
  constructor() {}

  set(key: string, value: any, ttl: number = 360 /* 1 minute */) {
    lscache.set(key, value, ttl);
  }

  get(key: string) {
    return lscache.get(key);
  }

  remove(key: string) {
    lscache.remove(key);
  }

  clear() {
    localStorage.clear();
  }
}
